import Cookies from "js-cookie"
import { useEffect, useState } from "react"
import { FiAlertTriangle } from "react-icons/fi"
import { callSurrender, getId, loginUser } from "../api"
import { Input, Section } from "../components"
import { useAction, useAppState } from "../hooks"
import { EInfoMessageType, TUser } from "../types"
import { AUTH_COOKIE, hash } from "../utils"
import { Modal } from "./Modal"


type LoginModalProps = {
    open: boolean
    handleClose: any
    user?: TUser
}

export const LoginModal = ({ open, handleClose, user }: LoginModalProps) => {
    const { setTokenAction, setInfoMessageAction } = useAction()
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [endGame, setEndGame] = useState(false)
    const [endCode, setEndCode] = useState('')
    const { state } = useAppState()

    const initLogin = () => {
        setErrorMessage('')
        if (login.length < 1 || password.length < 1) {
            setErrorMessage('Vyplňte přihlašovací jméno a heslo!')
            return
        }
        getId({ login: login, password: '' }).then((id) => {
            doLogin(id)
        }).catch(() => {
            setErrorMessage('Došlo k neočekávané chybě, v případě přetrvajících problémů kontaktujte organizátory.')
        })
    }

    const doLogin = (id: string) => {

        const encryptedPswd = hash(id+password)
        loginUser({ login: login, password: encryptedPswd }).then((response) => {
            if (response.token) {
                setTokenAction(response.token)
                setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: 'Přihlášení proběhlo úspěšně.', timeout: 20 })
                Cookies.set(AUTH_COOKIE, response.token, { expires: 7 })
                localStorage.setItem('authToken', response.token);
                handleClose()
            } else {
                setErrorMessage(response.errorMessage || 'Přihlášení se nezdařilo. Ujistěte se, že zadáváte správný název týmu a heslo, v případě problémů kontaktujte organizátory.')
                console.log(response.errorMessage)
            }
        }).catch(() => {
            setErrorMessage('Došlo k neočekávané chybě, v případě přetrvajících problémů kontaktujte organizátory.')
        })
    }

    const doLogout = () => {
        setTokenAction(undefined)
        Cookies.remove(AUTH_COOKIE)
        localStorage.removeItem('authToken');
        setInfoMessageAction({ type: EInfoMessageType.ALERT, message: 'Tým byl odhlášen.', timeout: 20 })
    }

    const endGameClick = () => {
        if (state?.token) {
            if (endCode == '2') {
                callSurrender({ token: state.token }).then(res => {
                    if (res.message) {
                        setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.message, timeout: 60 })
                        handleClose()
                    } else if (res.errorMessage) {
                        console.log('ERROR')
                        console.log(res.errorMessage)
                        setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                        handleClose(false)
                    }
                })
            } else {
                setEndGame(true)
            }
        }
    }

    useEffect(() => {
        setLogin('')
        setPassword('')
        setErrorMessage('')
    }, [open])


    return (
        <>
            {user
                ?
                <Modal open={open} handleClose={handleClose} headline='Odhlásit se' errorMessage={errorMessage}>
                    <>
                        <Section>
                            <span>Přihlášený uživatel:</span> <span>{user.Name}</span>
                        </Section>
                        <div className='modal__buttons'>
                            <button className='button' onClick={doLogout}> Odhlásit se</button>
                        </div>
                        <Section delimeter={true }>
                            <div></div>
                        </Section>
                        <div className='modal__buttons'>
                            <button className='button' onClick={endGameClick}> Ukončit hru</button>
                        </div>
                        {
                            endGame
                                ? <>
                                    <span>Vyplňte číslici a znovu stiskněte tlačítko Ukončit hru.</span>
                                    <Input
                                        label='1+1='
                                        type='text'
                                        value={endCode}
                                        setValue={e => setEndCode(e.target.value)}
                                        errorMessage=''
                                    />
                                </>
                                : <></>
                        }
                    </>
                </Modal >
                :
                <Modal open={open} handleClose={handleClose} headline='Přihlásit se' errorMessage={errorMessage}>
                    <div>
                        <Input
                            label='Jméno'
                            type='text'
                            value={login}
                            setValue={e => setLogin(e.target.value)}
                            errorMessage=''
                        />

                        <Input
                            label='Heslo'
                            type='password'
                            value={password}
                            setValue={e => setPassword(e.target.value)}
                            errorMessage=''
                        />

                        <div className='modal__buttons'>
                            <button className='button' onClick={initLogin}> Přihlásit se</button>
                        </div>

                    </div>
                </Modal>
            }
        </>
    )
}